import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import TableAHSF from "../../../../Components/TableAHSF";
import AddEditeSummary from "./AddEditeSummary";
import PopupAHSF from "../../../../Components/PopupAHSF";
import { setRefreshTable } from "../../../../Redux/Reducers/Shared/VariousVariables";
import Swal from "sweetalert2";
import {
  DeleteDetailsOfResearchSubmittedForAwardFiveYears,
  DetailsResearchSubmittedForAward,
} from "../../../../Redux/Reducers/Submitter/DetailsOfResearchSubmittedForAwardLastFiveYears";
import SummaryHeaderTable from "./SummaryHeaderTable";
import TableAHSFDragDrop from "../../../../Components/TableAHSF/TableAHSFDragDrop";
import loadConfig from "../../../../Services/Api/ApiServices";

const SummaryOfTheScientificContribution = (props) => {
  const [jsonData, setJsonData] = useState({});
  const [jsonLoding, setJsonLoding] = useState(false);

  const dispatch = useDispatch();
  const { ApplicationInformationId } = useParams();
  const culomEdite = ["email", "fullName"];
  const staticKeyEdite = ["userGUID", "ssoguid", "lastUpdate"];
  const navigate = useNavigate();
  const [PopupComponentStatus, SetPopupComponentStatus] = useState(false);
  const [
    detailsOfResearchSubmittedForAwardLastFiveYearsId,
    setdetailsOfResearchSubmittedForAwardLastFiveYearsId,
  ] = useState();
  const lang = useSelector((state) => state.languageReducer.Language);

  const RequestAccessor = [
    {
      KeyName: "researchSorting",
      ShowStatus: true,
      NmaeColumn: " ترتيب البحث",
      NmaeColumnEN: "Research Sorting",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "referenceAPACitation",
      ShowStatus: true,
      NmaeColumn: " المرجع (APA Citation)",
      NmaeColumnEN: "Reference APA Citation",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "numberOfCitations",
      ShowStatus: true,
      NmaeColumn: " عدد مرات الرجوع للبحث",
      NmaeColumnEN: "Number Of Citations",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName:
        lang != "en" ? "participationTypeNameAr" : "participationTypeNameEn",
      ShowStatus: true,
      NmaeColumn: " نوع المشاركة",
      NmaeColumnEN: "Participation Type",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "timePeriodNumber",
      ShowStatus: true,
      NmaeColumn: " سنة النشر",
      NmaeColumnEN: "Year Of Publication",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "researchRelevance",
      ShowStatus: true,
      NmaeColumn: "  صلة البحث بموضوع الجائزة",
      NmaeColumnEN: "Research Relevance",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "attachedResearchPaper",
      ShowStatus: true,
      NmaeColumn: "  مرفق الورقة البحثية",
      NmaeColumnEN: "Attached Research Paper",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
      typeColumn: "file",
    },
  ];

  const OtherMainBtns = [
    {
      Click: async (e) => {
        let data = JSON.parse(e.target.value);
        console.log(data, "eeeeeeeeeeeeeeeeeeee");
        SetPopupComponentStatus(true);
        dispatch(
          DetailsResearchSubmittedForAward({
            applicationInformationId:
              localStorage.getItem("ApplicationInformationId") ||
              ApplicationInformationId,
          })
        );

        setdetailsOfResearchSubmittedForAwardLastFiveYearsId(
          data.detailsOfResearchSubmittedForAwardLastFiveYearsId
        );
      },

      // content: [
      //   <span className="edit-animated">
      //     <i className="bi bi-pencil-fill"></i>
      //   </span>,
      // ],

      className: props.disabled ? "bi bi-eye-fill" : "bi bi-pencil-fill",
      id: "editBtn",
      title: "عرض الطلب",
      ShowStatus: true,
      ShowHideBtn: [],
    },
    {
      Click: async (e) => {
        let data = JSON.parse(e.target.value);

        Swal.fire({
          title:
            lang != "en"
              ? "هل انت متأكد من الحذف "
              : "Are you sure you want to delete?",
          icon: "error",
          // iconHtml: "؟",
          confirmButtonText: lang == "ar" ? "تأكيد" : "Confirmed",
          cancelButtonText: lang == "ar" ? "إلغاء" : "Cancel",
          showCancelButton: true,
          showCloseButton: true,
        }).then(async (res) => {
          if (res.isConfirmed == true) {
            var result = await dispatch(
              DeleteDetailsOfResearchSubmittedForAwardFiveYears({
                detailsOfResearchSubmittedForAwardLastFiveYearsId:
                  data.detailsOfResearchSubmittedForAwardLastFiveYearsId,
              })
            );
            if (result.payload.code == 200) {
              dispatch(
                DetailsResearchSubmittedForAward({
                  applicationInformationId:
                    localStorage.getItem("ApplicationInformationId") ||
                    ApplicationInformationId,
                })
              );

              Swal.fire({
                position: "center",
                icon: "success",
                title: lang != "en" ? "تم الحذف بنجاح" : "Deleted Successfully",

                showConfirmButton: false,
                timer: 1500,
                // width: "500px",
              });
              dispatch(
                setRefreshTable({ tableId: "DetailsOfResearchSubmitted" })
              );
            }
          }
        });
      },
      // content: (
      //   <span className="trash-icon">
      //     <span className="trash-wrapper">
      //       <span className="trash-lid"></span>
      //       <span className="trash-body"></span>
      //     </span>
      //   </span>
      // ),
      className: "bi bi-trash",
      id: "deleteBtn",
      title: "",
      ShowStatus: !props.disabled,
    },
  ];

  const RequestsColumns = [];
  const PopupOPjectData = {
    isPopupOpenStatus: true,
    isPopupOpenFunction: () => {},
    componentBody: (
      <div>
        {" "}
        <AddEditeSummary FormStatus="Add" />{" "}
      </div>
    ),
    titleEN:
      "Details of the research submitted to the award in the last 5 years and a summary of the scientific contribution",
    title:
      "تفاصيل الابحاث المقدمة للجائزة في اخر 5 سنوات ونبذة عن المساهمة العلمية",
    maxWidth: "640px",
    maxHeight: "600px",
  };

  const popUpBody = {
    isPopupOpenStatus: PopupComponentStatus,
    isPopupOpenFunction: () => {
      SetPopupComponentStatus(false);
    },

    componentBody: (
      <AddEditeSummary
        detailsOfResearchSubmittedForAwardLastFiveYearsId={
          detailsOfResearchSubmittedForAwardLastFiveYearsId
        }
        FormStatus={"Edit"}
        disabled={props.disabled}
      />
    ),
    titleEN:
      "Details of the research submitted to the award in the last 5 years and a summary of the scientific contribution",
    title:
      lang == "ar"
        ? "تفاصيل الابحاث المقدمة للجائزة في اخر 5 سنوات ونبذة عن المساهمة العلمية"
        : "Details of the research submitted to the award in the last 5 years and a summary of the scientific contribution",
    maxWidth: "640px",
    maxHeight: "600px",
  };
  const closePopupComponent = () => {
    SetPopupComponentStatus(false);
  };

  useEffect(() => {
    const getJson = async () => {
      const json = await loadConfig();
      setJsonData(json);
      setJsonLoding(true);
    };
    getJson();
  }, []);

  return (
    <>
      <TableAHSFDragDrop
        dragDropIcon={true}
        tableId="DetailsOfResearchSubmitted"
        culomEdite={culomEdite}
        lang={localStorage.getItem("lang")}
        TableComponent={[<SummaryHeaderTable />]}
        uniqueValue={""}
        valueButtonAction={""}
        URL={`api/SC_NT_RA_DetailsOfResearchSubmittedForAwardLastFiveYears/GetListDetailsOfResearchSubmittedForAwardLastFiveYears`}
        UrlBody={{
          applicationInformationId:
            localStorage.getItem("ApplicationInformationId") ||
            ApplicationInformationId,
        }}
        staticKeyEdite={staticKeyEdite}
        accessor={RequestAccessor}
        titelTable={
          "تفاصيل الابحاث المقدمة للجائزة في اخر 5 سنوات ونبذة عن المساهمة العلمية"
        }
        titelTableEN={
          "Details of the research submitted to the award in the last 5 years and a summary of the scientific contribution"
        }
        fileStoreName={"ResearchPaper"}
        selectRowNumber={true}
        checkBoksColumName="اختيار"
        sort={true}
        // pagination={true}
        // Nopagination={true}
        AppStatus={true}
        tableBtn={!props.disabled}
        sortTable={true}
        keyNameSort={"dateCreate"}
        dateKey="dateCreate"
        dateformat="DD/MM/YYYY h:mm a"
        arrayNameSort={["applicationNumber"]}
        search={true}
        openPopupState={false}
        DropdownArrayFiltration={[]}
        DropdownFiltration={false}
        exportData={true}
        hideIconsAction={true}
        checkBoks={false}
        nameColumAction=""
        showIconsApplication={true}
        total={false}
        arrayButton={OtherMainBtns}
        ArrayNameDataColum={RequestsColumns}
        columnKeyNameArray={[
          { keyName: "applicationNumber", nameColimn: " رقم الطلب" },
        ]}
        PopupOPjectData={PopupOPjectData}
        popUpTitle={"معلومات الطلب"}
        popUpBody={
          <PopupAHSF
            idssss="SecondarySectors"
            isPopupOpenStatus={popUpBody.isPopupOpenStatus}
            isPopupOpenFunction={popUpBody.isPopupOpenFunction}
            // title={popUpBody.title}
            componentBody={popUpBody.componentBody}
            maxWidth={popUpBody.maxWidth}
            maxHeight={popUpBody.maxHeight}
            titleEN={popUpBody.titleEN}
            title={popUpBody.title}
          />
        }
      />
    </>
  );
};

export default SummaryOfTheScientificContribution;
